import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/NalichnikiPrimeri.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox' // Добавлен импорт

class NalichnikiPrimeri extends React.Component {
  
  constructor(props) {
    super(props)
    this.state = {
      lightboxController: { // Добавлено состояние для лайтбокса
        toggler: false,
        slide: 1
      }
    }
  }

  // Добавлен обработчик для открытия лайтбокса
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, title } = this.props
    const { lightboxController } = this.state

    // Создаем массив источников для лайтбокса из всех изображений
    const imageSources = list.map(item => item.image).filter(Boolean)

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={title}
            className={styles.title}
          />
          
          {/* Добавлен компонент лайтбокса */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={imageSources}
            slide={lightboxController.slide}
          />

          <div className={`${styles.list}`}>
            {list.map( ( elm, k ) => {
              return (
                <div className={`${styles.block}`} key={k}>
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  {elm?.image &&
                    <Image 
                      className={styles.b_topimg} 
                      src={elm?.image} 
                      width={545} 
                      height={202} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k)} // Добавлен обработчик клика
                      style={{cursor: 'pointer'}}
                    />
                  }
                </div>
              )
            })}
          </div>
        </Container>
      </section>
    )
  }
}

NalichnikiPrimeri.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string
}

NalichnikiPrimeri.defaultProps = {
  list: [],
  title: ``
}

export default NalichnikiPrimeri